const $ = jQuery;

export default function makeTurnable(el) {
  $('body').on('touchstart touchend', (e) =>
    $(e.currentTarget).addClass('-is-touch-device')
  );

  let firstTouch = null;
  let lastTouch = null;
  let touchTarget = null;
  $(el).on('touchstart', function (e) {
    firstTouch = e.originalEvent.touches[0];
    lastTouch = e.originalEvent.touches[0];
    touchTarget = e.currentTarget;
  });

  $(el).on('touchmove', function (e) {
    if (!firstTouch) {
      firstTouch = e.originalEvent.touches[0];
    }
    lastTouch = e.originalEvent.touches[0];
  });

  $(el).on('touchend', function (e) {
    const distance = Math.sqrt(
      Math.pow(firstTouch.clientY - lastTouch.clientY, 2) +
        Math.pow(firstTouch.clientX - lastTouch.clientX, 2)
    );
    if (distance <= 20) {
      $(touchTarget).toggleClass('active');
    }
    touchTarget = null;
    firstTouch = null;
    lastTouch = null;
  });

  $(el).on('mouseenter', function (e) {
    e.preventDefault();
    if (!$('body').hasClass('-is-touch-device')) {
      return $(this).addClass('active');
    }
  });

  $(el).on('mouseleave', function (e) {
    e.preventDefault();
    if (!$('body').hasClass('-is-touch-device')) {
      return $(this).removeClass('active');
    }
  });
}
